// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3fac062a","414":"0c1e5c87"}[chunkId] + ".chunk.js";
};